// @LTG-ID: F-094
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-094, source `Journals/sde-vs-ebitda.html`
//        lines 293-325 (Figure 01 — $3.2M HVAC SDE-vs-EBITDA worked example).
// @CHANGED: 2026-02 session_004 (CHG-0062)
// @OWNER: web
//
// F-094 — Brief 02 Figure 01. Verbatim port of the source SVG side-by-side
// comparison: $620K SDE block (navy) vs $410K EBITDA block (gold) for the
// same $3.2M revenue HVAC company, with the $210K salary add-back delta
// called out on the right.

export const Brief02WorkedExample = () => {
    return (
        <div
            className="ltg-brief-infographic"
            data-testid="brief02-figure-01"
        >
            <span className="ltg-brief-infographic-label">
                Figure 01 &middot; The $3.2M HVAC example
            </span>
            <h4>Same business. Two earnings numbers. Two buyers.</h4>
            <svg
                viewBox="0 0 720 280"
                className="ltg-brief-compare-svg"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <text
                    x="40"
                    y="40"
                    fontFamily="Geist Mono, monospace"
                    fontSize="10"
                    fill="#6a7a92"
                    letterSpacing="1.2"
                >
                    $3.2M REVENUE HVAC COMPANY
                </text>

                <line x1="40" y1="260" x2="680" y2="260" stroke="#d8d3c6" />

                <rect x="80" y="100" width="200" height="160" fill="#0A2A5E" />
                <text x="180" y="90" fontFamily="Source Serif 4, serif" fontSize="14" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$620K SDE</text>
                <text x="180" y="195" fontFamily="Source Serif 4, serif" fontSize="11" fill="white" textAnchor="middle">includes</text>
                <text x="180" y="215" fontFamily="Source Serif 4, serif" fontSize="11" fill="white" textAnchor="middle">owner salary</text>
                <text x="180" y="235" fontFamily="Geist Mono, monospace" fontSize="10" fill="rgba(255,255,255,0.7)" textAnchor="middle" letterSpacing="0.8">UNDERWRITTEN BY</text>
                <text x="180" y="278" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">Individual buyer / SBA</text>

                <text x="320" y="170" fontFamily="Geist Mono, monospace" fontSize="14" fill="#B08D3E" textAnchor="middle" letterSpacing="2">vs</text>

                <rect x="360" y="155" width="200" height="105" fill="#B08D3E" />
                <text x="460" y="145" fontFamily="Source Serif 4, serif" fontSize="14" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$410K EBITDA</text>
                <text x="460" y="195" fontFamily="Source Serif 4, serif" fontSize="11" fill="white" textAnchor="middle">market-rate</text>
                <text x="460" y="215" fontFamily="Source Serif 4, serif" fontSize="11" fill="white" textAnchor="middle">manager deducted</text>
                <text x="460" y="235" fontFamily="Geist Mono, monospace" fontSize="10" fill="rgba(255,255,255,0.85)" textAnchor="middle" letterSpacing="0.8">UNDERWRITTEN BY</text>
                <text x="460" y="278" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">PE / strategic / family office</text>

                <text x="620" y="125" fontFamily="Source Serif 4, serif" fontSize="13" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">$210K</text>
                <text x="620" y="145" fontFamily="Geist Mono, monospace" fontSize="9" fill="#6a7a92" textAnchor="middle" letterSpacing="0.6">SALARY ADD-BACK</text>
                <path d="M 580 130 L 600 130" stroke="#6a7a92" strokeWidth="1" />
            </svg>
            <p className="ltg-brief-infographic-caption">
                On the same $3.2M revenue HVAC company, an individual
                SBA-financed buyer underwrites $620K of SDE. A PE buyer
                underwrites $410K of EBITDA after deducting a market-rate
                operator salary. Same business, $210K of cash flow difference,
                two different multiples applied.
                <cite>
                    Illustrative example using common HVAC operating margins
                    per CT Acquisitions 2026 and Profitability Partners 2025
                </cite>
            </p>
        </div>
    );
};

export default Brief02WorkedExample;
